import { gql } from "@apollo/client";

/**
 * Voids a single unbilled trip charge (AUT-5013).
 *
 * Airport operators accumulate one trip charge per LPR entry capture through the month and
 * are billed once, in aggregate, around the 10th. This strikes an individual trip before
 * that settlement collects it -- a duplicate capture, a vehicle that was not operating
 * commercially, a resolved dispute.
 *
 * Only valid before the trip has been billed: once a monthly charge has collected it, the
 * correction is a credit or refund against that charge, and the API rejects the void with a
 * message saying so.
 */
export const VOID_TRIP_CHARGE = gql`
  mutation VoidTripCharge($id: uuid!, $reason: String!, $voidedAt: timestamptz!) {
    void_trip_charge(id: $id, reason: $reason, voided_at: $voidedAt) {
      transactionId: transaction_id
      status
      voidedAt: voided_at
      reason
      updatedAt: updated_at
    }
  }
`;

export interface VoidTripChargeData {
  void_trip_charge: {
    transactionId: string;
    /** Resulting transaction status; "canceled" on success. */
    status: string;
    voidedAt: string;
    reason: string;
    updatedAt: string;
  };
}

export interface VoidTripChargeVars {
  id: string;
  reason: string;
  voidedAt: Date;
}

export default VOID_TRIP_CHARGE;
